import { useEffect, useRef } from 'react'

import { setTag } from '@sentry/react'

export default function useSetSentryUser({ walletAddresses }: { walletAddresses: string[] }) {
  const ref = useRef<string[]>([])
  useEffect(() => {
    const allIncluded = walletAddresses.every((address) => ref.current.includes(address))
    const newData = [...new Set([...ref.current, ...walletAddresses])]
    if (allIncluded || !newData.length) return
    ref.current = newData // push more only
    newData.forEach((address) => {
      setTag('wallet', address)
      setTag('wallet', address?.toLowerCase())
    })
  }, [walletAddresses])
}
